import { List } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import MapViewComponent from '../components/Map/MapView';
import * as restaurantActions from '../actions/restaurantActions';
import * as basketActions from '../actions/basketActions';
import * as _ from 'lodash';
import {checkBasketIsEmpty} from "../helpers";
import {confirmAlert} from "react-confirm-alert";
import {translate} from 'react-i18next';
import Spinner from "../components/Spinner/Spinner";
import {DEFAULT_LANGUAGE} from '../constants';


class MapScreen extends Component {

  constructor(props) {
    super(props);
    this.displayInfo = this.displayInfo.bind(this);
    this.closeInfo = this.closeInfo.bind(this);
    this.selectRestaurant = this.selectRestaurant.bind(this);
    this.changeRestaurant = this.changeRestaurant.bind(this);
    this.state = {
      showInfoIndex: 0
    }
  }

  displayInfo(value) {
    this.setState({
      showInfoIndex: value
    })
  }

  closeInfo() {
    this.setState({
      showInfoIndex: -1
    })
  }

  static getDerivedStateFromProps(props, state) {
    let showInfoIndex = state.showInfoIndex;
    if (!state.showInfoIndex && props.restaurants.selectedId) {
      showInfoIndex = props.restaurants.selectedId;
    }
    return {
      showInfoIndex: showInfoIndex
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.restaurants.selectedId !== prevProps.restaurants.selectedId) {
      this.displayInfo(this.props.restaurants.selectedId)
    }
  }

  changeRestaurant(id) {
    const {selectRestaurant, startSelectedFetchRestaurant, endSelectedFetchRestaurant} = this.props;
    startSelectedFetchRestaurant();
    selectRestaurant(id).then(() => {
      endSelectedFetchRestaurant();
      const restaurantForUrl = this.props.restaurants.list.find(obj => {
        return obj.id === id
      });
      const lng = this.props.language.defaultLanguage || DEFAULT_LANGUAGE;
      this.props.history.push(`/${lng}/${restaurantForUrl.name_for_url}/products/pizza`);
    });
  }

  selectRestaurant(id) {
    const {restaurants, basket, t, clearBasket} = this.props;
    if (restaurants.selectedId === id) {
      this.changeRestaurant(id);
    } else {
      if (checkBasketIsEmpty(basket)) {
        this.changeRestaurant(id);
      } else {
        confirmAlert({
          message: t('confirm_restaurant_change'),
          buttons: [
            {
              label: t('continue'),
              onClick: () => {
                clearBasket();
                this.changeRestaurant(id);
              }
            },
            {
              label: t('cancel'),
            },
          ],
        });
      }
    }
  }

  render() {
    const {displayInfo, selectRestaurant, closeInfo} = this;
    const {restaurants, t} = this.props;
    if (!List.isList(restaurants.list)) return MapScreen.renderLoading(t);
    if (_.isUndefined(restaurants.selectedId)) return MapScreen.renderLoading(t);
    const {showInfoIndex} = this.state;
    return (
      <MapViewComponent
        restaurants={restaurants.list}
        selectRestaurant={selectRestaurant}
        showInfoIndex={showInfoIndex}
        isOpen={_.isNumber(showInfoIndex)}
        displayInfo={displayInfo}
        closeInfo={closeInfo}
      />
    );
  }

  static renderLoading(t) {
    return (
      <Spinner text={t('loading_restaurants')} />
    );
  }
}

function mapStateToProps(state) {
  return {
    restaurants: state.restaurants,
    basket: state.basket,
    language: state.language
  }
}

function mapDispatchToProps(dispatch) {
  return {
    selectRestaurant: bindActionCreators(restaurantActions.selectedRestaurant, dispatch),
    startSelectedFetchRestaurant: bindActionCreators(restaurantActions.startSelectedFetchRestaurant, dispatch),
    endSelectedFetchRestaurant: bindActionCreators(restaurantActions.endSelectedFetchRestaurant, dispatch),
    clearBasket: bindActionCreators(basketActions.clearBasket, dispatch)
  }
}

MapScreen.propTypes = {
  list: PropTypes.object,
  selectRestaurant: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(translate('translations')(MapScreen));


// WEBPACK FOOTER //
// ./src/containers/Map.js